import axios from 'axios'
import { NotificationType } from '@/modules/configurationModule/detail/notifications/models/notification-types'

class NotificationTypeServices {
    async getAllNotificationTypes(isGlobal: boolean): Promise<NotificationType[]> {
        const response = await axios.get(`/configuration/notificationTypes?isGlobal=${isGlobal}`)
        return response.data
    }
}
export const notificationTypeServices = new NotificationTypeServices()
